/*---------------------------------------------------------------
    OFFICE EVENT TYPE
  ---------------------------------------------------------------*/
export enum OfficeEventType {
  ADD = "ADD",
  EDIT = "EDIT",
  REMOVE = "REMOVE",
}

/*---------------------------------------------------------------
    OFFICES
  ---------------------------------------------------------------*/

export interface Office {
  id: string;
  name: string | null;
  code: string | null;
  internalMark: string | null;
  description: string | null;
  status: string | null;
  primaryEmail: OfficeEmail | null;
  primaryPhone: OfficePhone | null;
  primaryAddress: OfficeAddress | null;
}

/*---------------------------------------------------------------
    OFFICES -> SEARCH
  ---------------------------------------------------------------*/

export interface OfficeSearchFormValues {
  search: string | null;
}

export interface OfficeRow {
  id: string | null;
  name: string | null;
  code: string | null;
  internalMark: string | null;
  description: string | null;
  status: string | null;
  primaryEmail: OfficeEmail | null;
  primaryPhone: OfficePhone | null;
  primaryAddress: OfficeAddress | null;
  created: Date | null;
}

/*---------------------------------------------------------------
    OFFICES -> EDIT
  ---------------------------------------------------------------*/
export interface OfficeEditFormValues {
  id?: string | null;
  name: string | null;
  code: string | null;
  internalMark: string | null;
  description: string | null;
  status: string | null;
}

/*---------------------------------------------------------------
    EMAILS
  ---------------------------------------------------------------*/

export interface OfficeEmail {
  id: string;
  emailAddress: string;
  description: string;
  primary: boolean;
}

export interface OfficeEmailRow {
  id: string;
  emailAddress: string;
  description: string;
  primary: boolean;
}

export interface OfficeEmailEditFormValues {
  id?: string | null;
  emailAddress: string | null;
  description: string | null;
  primary: boolean | null;
}

/*---------------------------------------------------------------
    PHONE
  ---------------------------------------------------------------*/
export interface OfficePhone {
  id: string;
  phoneTypeId: string;
  phoneNumber: string;
  description: string;
  primary: boolean;
}

export interface OfficePhoneRow {
  id: string;
  phoneTypeId: string;
  phoneNumber: string;
  description: string;
  primary: boolean;
}

export interface OfficePhoneEditFormValues {
  id?: string | null;
  phoneTypeId: string | null;
  phoneNumber: string | null;
  description: string | null;
  primary: boolean;
}

/*---------------------------------------------------------------
    ADDRESS
  ---------------------------------------------------------------*/

export interface OfficeAddress {
  id: string;
  city: string;
  country: string;
  line1: string;
  line2: string;
  postalCode: string;
  state: string;
  description: string | null;
  primary: boolean;
  latitude: number | null;
  longitude: number | null;
}

export interface OfficeAddressRow {
  id: string;
  city: string;
  country: string;
  line1: string;
  line2: string;
  postalCode: string;
  state: string;
  description: string;
  primary: boolean;
  latitude: number | null;
  longitude: number | null;
}

export interface OfficeAddressEditFormValues {
  id?: string | null;
  city: string | null;
  country: string | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  state: string | null;
  description: string | null;
  primary: boolean | null;
  latitude: number | null;
  longitude: number | null;
}

/*---------------------------------------------------------------
    NOTES
  ---------------------------------------------------------------*/

export interface OfficeNote {
  id: string;
  content: string;
  important: boolean;
  created: Date;
}

export interface OfficeNoteRow {
  id: string;
  content: string;
  important: boolean;
  created: Date;
}

export interface OfficeNoteEditFormValues {
  id?: string | null;
  content: string | null;
  important: boolean | null;
}

